/**
 * Internal dependencies
 */
import { SET_NAVBAR_OFFSET } from '../actionTypes';
import { createAction } from '../action-creators';
import { RootState } from '../types';

export const setNavBarOffset =
	createAction<RootState['navBarOffset']>(SET_NAVBAR_OFFSET);
